import { createContext } from "react";

export const SocialMediaPublishStatusContext = createContext();
